import store from '../store'

export const loadDefaultClinicStates = () => {
  store.dispatch('healthPlans/getAllHealthPlans', null, { root: true })
  store.dispatch('healthPlans/getTissClinicHealthPlans', null, { root: true })
}


